import React from 'react';
import { Accordion } from '@components/Accordion';
import { useFetchSafetyDatasheetQuery } from './SafetyDatasheet.service';
import { getProductName } from './SafetyDatasheet.helpers';
import { ReplacementTitle } from './components/ReplacementTitle';
import './SafetyDatasheet.scss';
import { DatasheetDownloadableItem } from './components/DatasheetDownloadableItem';

export const SafetyDataSheet = () => {
  const { data: safetyDataSheets } = useFetchSafetyDatasheetQuery();

  return (
    <div className='l-content l-page-center'>
      <div style={{ width: '100%' }}>
        <div className='l-section l-section-100 l-section-padding'>
          {safetyDataSheets && safetyDataSheets.SafetyDataSheetItems.length > 0 && (
            <div className='c-document-datasheet'>
              {[...safetyDataSheets.SafetyDataSheetItems]
                .sort((a, b) => a.ProductName.localeCompare(b.ProductName))
                .map(
                  (
                    {
                      ProductName,
                      ItemNumber,
                      LifeCycleLabel,
                      LifeCycleStatus,
                      Replaces,
                      ReplacesLabel,
                      ReplacedBy,
                      ReplacedByLabel,
                      SafetyDataSheets,
                    },
                    index
                  ) => {
                    const pName = getProductName(
                      ProductName,
                      ItemNumber,
                      LifeCycleStatus,
                      LifeCycleLabel
                    );

                    return (
                      <React.Fragment key={index}>
                        <Accordion.Container>
                          <Accordion.Section
                            tab={{
                              id: 1,
                              name: (
                                <>
                                  <span>{pName}</span>
                                  {Replaces.length > 0 && (
                                    <ReplacementTitle label={ReplacesLabel} items={Replaces} />
                                  )}
                                  {ReplacedBy.length > 0 && (
                                    <ReplacementTitle label={ReplacedByLabel} items={ReplacedBy} />
                                  )}
                                </>
                              ),
                            }}
                            className='c-accordion-tabs-head-gray'
                            isOpen={false}
                            url={null}
                          >
                            <hr></hr>
                            <div
                              data-proxyid='Safety Data Sheets'
                              className='c-accordion-tabs-body c-accordion-tabs-is-open'
                            >
                              {SafetyDataSheets.map((datasheet, index) => {
                                return (
                                  <DatasheetDownloadableItem
                                    key={index}
                                    item={datasheet}
                                    versionLabel={safetyDataSheets.VersionLabel}
                                    sizeLabel={safetyDataSheets.SizeLabel}
                                    languageLabel={safetyDataSheets.LanguageLabel}
                                  />
                                );
                              })}
                            </div>
                          </Accordion.Section>
                        </Accordion.Container>
                        <div style={{ marginBottom: '2px' }} />
                      </React.Fragment>
                    );
                  }
                )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
